var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoulette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 359 336",
    width: 349,
    height: 327,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer 12-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #807ffb } \n\t\t.s1 { fill: #bcbeff } \n\t\t.s2 { fill: #6c6ee9 } \n\t\t.s3 { fill: #001c2b } \n\t\t.s4 { fill: #f9f5e0 } \n\t\t.s5 { fill: #a09fff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m305.8 79.3l-16.2-19.3-4.6 3.7c-35.7-16.3-91.9-3.8-138.9 33.9-47.1 37.7-70.4 89-61.1 126.4l-4.6 3.7 16.3 19.3c30.4 36.3 102 28.1 159.7-18.2 57.8-46.3 79.9-113.2 49.5-149.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m240 209c-57.7 46.3-128.1 55.9-157.1 21.3-29-34.5-5.7-100 52.1-146.3 57.7-46.4 128.1-55.9 157.1-21.4 29 34.4 5.7 100-52.1 146.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m230.7 197.9c-49.5 39.8-109.7 48.1-134.4 18.7-24.8-29.5-4.7-85.5 44.9-125.2 49.5-39.8 109.7-48.1 134.4-18.7 24.7 29.5 4.6 85.5-44.9 125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m146.5 98.8c48.8-39.2 108.1-47.8 133.3-19.7q-1.9-3.5-4.4-6.5c-24.7-29.4-84.9-21-134.3 18.6-49.5 39.7-69.5 95.6-44.9 125q0.5 0.6 1 1.1c-17.3-30.6 3.2-81.6 49.3-118.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m228.8 196.8c-41.6 33.3-90.8 41.8-110 19-19.2-22.9-1.1-68.4 40.5-101.8 41.5-33.3 90.8-41.8 110-18.9 19.2 22.8 1.1 68.3-40.5 101.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m194 96.3c-2.9 1.3-5.9 2.8-8.8 4.4l-2.7 46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m177.9 105.1q-4.2 2.5-8.2 5.3l13.3 36.3-5.1-41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m216.5 88.2q-6.1 1.6-12.1 3.8l-22.1 54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m151.3 126q-3.1 2.9-6 5.9l37.7 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m204.6 91.8q-5.4 2-10.9 4.6l-11.3 50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m169.9 110.4q-3.5 2.5-7 5.2l20.2 31-13.2-36.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m156.8 120.9q-2.9 2.5-5.6 5.1l31.9 20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m145.4 132q-3.1 3.3-6 6.5l43.7 7.8-37.7-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m163.1 115.6q-0.6 0.5-1.3 1-2.6 2.1-5.1 4.2l26.4 25.7-20-30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m268.5 129.5c1.2-4.2 1.8-8.5 1.8-12.9l-87.6 30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m263.5 143c2.1-4.1 3.8-8.5 5.1-13l-85.7 17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m270.3 116.2c0.1-3.9-0.6-7.8-2-11.4l-85.8 42.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m256 156.5q4.3-6.1 7.7-12.8l-80.6 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m241 86.1c-4.4-0.3-8.8-0.3-13.1 0.3l-45.6 60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m252.4 88.8c-3.7-1.4-7.6-2.2-11.5-2.5l-58.6 60.6 70.1-58.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m228 86.2q-5.9 0.7-11.7 2.2l-34 58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s4",
    d: "m261.7 94.6c-2.7-2.4-5.9-4.3-9.3-5.6l-70 57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m268.3 104.5c-1.4-3.7-3.7-7-6.7-9.6l-79.2 52 85.9-42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m185.4 100.6q-3.9 2.1-7.9 4.6l5.2 41.6 2.8-46.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m191.4 212.2q8.2-3.7 15.8-8.4l-24.1-56.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m173.9 218.8q9.3-2.7 18.2-6.8l-8.4-65.1-9.7 71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m130.6 218c3.8 1.9 8 3.1 12.3 3.7l41.1-74.8-53.4 71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m142.8 221.9c4.7 0.5 9.6 0.6 14.4 0l26.8-75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m157 222.1c5.9-0.6 11.7-1.8 17.3-3.5l9.7-71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m183.1 147.8l63.4 21.4q5.2-5.9 9.7-12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m206.8 203.8q8-4.9 15.4-10.6l-39.1-45.8 23.7 56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m234.4 182.3q6.5-6.1 12.4-12.9l-63.7-21.7 51.3 34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m221.9 193.2q1.2-0.9 2.3-1.9c3.7-2.9 7.1-5.8 10.4-8.9l-51.6-34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m134.7 144.7q-2.7 3.4-5.1 6.9l53.5-5.2-48.3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m121.7 210.7l0.3 0.4c2.4 2.8 5.3 5.1 8.7 6.8l53.2-71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m120.7 168.8q-2.1 4.8-3.5 9.9l66.2-31.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m129.7 152.1c-1.8 2.6-3.5 5.2-5 7.8l58.4-13-53.4 5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m139.5 138.7q-2.5 2.9-4.9 5.8l48.5 1.8-43.5-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m124.8 160.2q-2.3 4-4.2 8.3l62.7-21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m116.5 200.1c1 3.8 2.7 7.4 5.2 10.5l62.1-63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m115.6 189.3c-0.2 3.6 0.1 7.2 0.9 10.6l67.2-53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m117.2 179q-1.3 5-1.6 10.1l67.9-42.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m217.2 182.6c-32.5 25.9-70 33.8-83.6 17.8-13.6-16.1 1.6-50.1 34.2-76 32.6-25.9 70-33.8 83.7-17.8 13.6 16.1-1.7 50.1-34.3 76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m251.7 139.6c0 0-37.2 2.2-61 14l2.7-17.1c0 0 15.9-6.7 61.2-5.5 0 0-1.8 6.9-2.9 8.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m143.9 108.5c-3.4 3.2-6.9 5.3-7.7 4.4-0.9-0.9 1.3-4.1 4.7-7.4 3.5-3.3 7-5.3 7.8-4.5 0.8 0.9-1.3 4.2-4.8 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m200.6 74.8c-0.5-3.4 0.1-6.2 1.3-6.4 1.1-0.2 2.5 2.4 2.9 5.7 0.5 3.3-0.1 6.1-1.2 6.3-1.2 0.2-2.6-2.3-3-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m104.5 164.4c-3.3-0.7-5.7-2.2-5.5-3.4 0.3-1.3 3.2-1.9 6.6-1.3 3.3 0.6 5.8 2.1 5.5 3.4-0.3 1.3-3.2 1.8-6.6 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m282.2 124.6c-3.4 0.6-5.9 2.2-5.7 3.5 0.1 1 1.9 1.6 4.3 1.5q0.8-2.5 1.5-5c0 0-0.1 0-0.1 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m115.1 225.3c-3-2.2-4.9-4.6-4.3-5.5 0.7-0.8 3.7 0.2 6.7 2.4 2.9 2.1 4.8 4.6 4.1 5.5-0.6 0.8-3.6-0.2-6.6-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s5",
    d: "m265.9 79.7c-3.1-2-5.1-4.4-4.5-5.3 0.7-0.9 3.7 0 6.8 2.1 3.1 2 5.1 4.4 4.5 5.2-0.7 0.9-3.7 0-6.8-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m199.9 133.3l-29.3-17-11.8 11.6 14.9 28.2c8.8 9.1 34.2-14.1 26.2-22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m168.1 126.3c-5.7 5-12.7 6.5-15.7 3.3-2.9-3.1-0.6-9.8 5.1-14.8 5.6-5 12.7-6.5 15.6-3.3 2.9 3.1 0.7 9.8-5 14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m165.4 123.2c-5.7 5-12.7 6.5-15.6 3.2-3-3.2-0.7-9.8 5-14.8 5.7-5 12.7-6.5 15.6-3.3 3 3.2 0.7 9.8-5 14.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m157.3 114.7c-3.4 3-7.7 3.9-9.5 2-1.8-1.9-0.4-6 3-9.1 3.5-3 7.8-3.9 9.6-2 1.8 2 0.4 6-3.1 9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m147.7 103.6c-2.5 2.3-5.6 2.9-6.9 1.5-1.3-1.4-0.3-4.3 2.2-6.5 2.5-2.2 5.6-2.9 6.9-1.5 1.3 1.4 0.3 4.3-2.2 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m148.6 114l-7.4-11.1 6.5-5.4 9.7 8.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoulette);
export default __webpack_public_path__ + "static/media/roulette.bdfa6517e7fb94a9ac97221c81bcc4f9.svg";
export { ForwardRef as ReactComponent };